var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini_game_bet"},[_c('div',{staticClass:"mini_game"},[_c('div',{staticClass:"m3"},[_c('div',{staticClass:"mini_fram"},[_c('iframe',{attrs:{"id":"token-gamefram","scrolling":"no","frameborder":"0","allowtransparency":"true","allowfullscreen":"","src":_vm.iframUrl}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }